import React, {useCallback, useEffect, useRef, useState} from "react";
import {Languages} from "../../constants";
import {observer} from "mobx-react-lite";
import {translationStore} from "../../store/translationStore";
import "./index.scss";
import useOnClickOutside from "../../hooks/useOnClickOutside";
import {isMobile} from "react-device-detect";

const Translation = observer(() => {
    const [toggle, setToggle] = useState(false);
    const [navbarHeight, setNavbarHeight] = useState(0);
    const ref = useRef();
    const navbarRef = useRef();
    const {setActiveLanguage, activeLanguage} = translationStore;

    const heightRef = useRef(window.innerHeight - (2.67 / 100) * 30 * window.innerWidth  - 100);

    useOnClickOutside(ref, () => setToggle(false));

    const handleClick = () => {
        setToggle(prev => !prev);
    };

    useEffect(() => {
        setNavbarHeight(navbarRef.current?.clientHeight);
    }, [navbarRef.current])

    const handleChangeLang = useCallback((language) => {
        window?.$hoory?.setLocale(language.value);
        setActiveLanguage(language);
        setToggle(false);
    }, [activeLanguage]);

    return (
        <div ref={ref} className="translation-container">
            <button className={`lang-btn ${toggle ? "active" : ""}`}
                    onClick={handleClick}>{Languages[activeLanguage].circleIcon}</button>
            <ul ref={navbarRef} className={`translation-navbar ${toggle ? "active" : ""}`} style={{
                maxHeight: isMobile ? heightRef.current : "auto",
                paddingTop: isMobile && heightRef.current < navbarHeight ? "6rem" : "unset",
            }}>
                {
                    Object.keys(Languages).map((lang, index) => (
                            <li onClick={() => handleChangeLang(Languages[lang])}
                                key={index}>{Languages[lang].circleIcon}<span>{Languages[lang].title}</span></li>
                        )
                    )
                }
            </ul>
        </div>
    );
});


export default Translation;